// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__q3alR","errors":"Errors_errors__1FWC8"};